import { render, staticRenderFns } from "./ModalViderPanier.vue?vue&type=template&id=db20a238"
import script from "./ModalViderPanier.vue?vue&type=script&lang=js"
export * from "./ModalViderPanier.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports